/**
 * 售后 Support Ticket — 与 coffee_menu.perms / SaTokenConfigure 对齐。
 */
import { SUPPORT_TICKET_MENU_IDS } from '@/constants/supportTicket'

export const SUPPORT_TICKET_PERM = {
  CREATE: 'support:ticket:create',
  VIEW_OWN: 'support:ticket:view:own',
  MANAGE: 'support:ticket:manage',
  REPLY: 'support:ticket:reply'
}

/** menuId → perms（SSOT：087/088 patch + COFFEE_MENU_ID_REGISTRY） */
export const SUPPORT_TICKET_MENU_PERMS = {
  [SUPPORT_TICKET_MENU_IDS.group]: '',
  [SUPPORT_TICKET_MENU_IDS.create]: SUPPORT_TICKET_PERM.CREATE,
  [SUPPORT_TICKET_MENU_IDS.mine]: SUPPORT_TICKET_PERM.VIEW_OWN,
  [SUPPORT_TICKET_MENU_IDS.workbench]: SUPPORT_TICKET_PERM.MANAGE,
  [SUPPORT_TICKET_MENU_IDS.reply]: SUPPORT_TICKET_PERM.REPLY,
  [SUPPORT_TICKET_MENU_IDS.playbook]: SUPPORT_TICKET_PERM.PLAYBOOK_MANAGE
}

/** enName → perms */
export const SUPPORT_TICKET_EN_PERMS = {
  supportTicketGroup: '',
  supportTicketCreate: SUPPORT_TICKET_PERM.CREATE,
  supportTicketMine: SUPPORT_TICKET_PERM.VIEW_OWN,
  supportTicketWorkbench: SUPPORT_TICKET_PERM.MANAGE,
  supportTicketReply: SUPPORT_TICKET_PERM.REPLY,
  supportPlaybook: SUPPORT_TICKET_PERM.PLAYBOOK_MANAGE
}

function parsePermissions () {
  try {
    const raw = sessionStorage.getItem('permissions')
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed : []
  } catch (e) {
    return []
  }
}

export function hasSupportTicketPermission (code) {
  if (!code) return true
  const perms = parsePermissions()
  return perms.includes('*:*:*') || perms.includes(code)
}

export function canAccessSupportTicketCreate () {
  return hasSupportTicketPermission(SUPPORT_TICKET_PERM.CREATE)
}

export function canAccessSupportTicketMine () {
  return hasSupportTicketPermission(SUPPORT_TICKET_PERM.VIEW_OWN)
}

export function canAccessSupportTicketWorkbench () {
  return hasSupportTicketPermission(SUPPORT_TICKET_PERM.MANAGE)
}

export function canSupportTicketReply () {
  return hasSupportTicketPermission(SUPPORT_TICKET_PERM.REPLY)
}

export function canManageSupportPlaybook () {
  return hasSupportTicketPermission(SUPPORT_TICKET_PERM.PLAYBOOK_MANAGE)
}



// WEBPACK FOOTER //
// ./src/utils/supportTicketPermissions.js